export default __webpack_public_path__ + "static/media/3.9a88afc5.mp3";